export default "__VITE_ASSET__34f9720c__"